import {IStep} from "../step/step.objects";
import {BookSessionType} from "../../constants";
export type QuestionStateMap = {[id: string]: QuestionState};
export type RecordReadingStateMap = {[id: string]: IReviewWord[]};

// NOTE: The <any> cast is a hack to allow string-based enums (hopefully someday unnecessary)

export enum WordWallMode {
    GUIDED = <any>"Guided",
    EXPLORATORY = <any>"Exploratory"
}

export enum CompletionState {
    NOT_STARTED = <any>"NotStarted",
    INCOMPLETE = <any>"Incomplete",
    COMPLETED = <any>"Completed"
}

export enum ReviewWordReason {
    TRY_AGAIN = <any>"NotRecognized",
    NOT_CONFIDENT = <any>"NotConfident",
    GREAT_JOB = <any>"NoNeed"
}

export enum ReviewWordColor {
    NEEDS_WORK = <any>"NeedsWork",
    TRY_AGAIN = <any>"TryAgain",
    GREAT_JOB = <any>"GreatJob"
}

export enum RecordingBadge {
    CHECKMARK = <any>"Checkmark",
    SILVER = <any>"Silver",
    GOLDEN = <any>"Golden"
}

export enum StepStatus {
    PROFICIENCY = <any>"PROFICIENCY",
    COMPLETION = <any>"COMPLETION",
    PREVIOUSLY_PROFICIENCY = <any>"PREVIOUSLY_PROFICIENCY",
    PREVIOUSLY_COMPLETION = <any>"PREVIOUSLY_COMPLETION",
    UNDONE = <any>"UNDONE"
}

export enum QuestionState {
    NOT_ASKED = <any>"NotAsked",
    NOT_ANSWERED = <any>"NotAnswered",
    ANSWERED_INCORRECTLY = <any>"AnsweredIncorrectly",
    ANSWERED_CORRECTLY = <any>"AnsweredCorrectly",
    PREVIOUSLY_ANSWERED_INCORRECTLY = <any>"PreviouslyAnsweredIncorrectly",
    PREVIOUSLY_ANSWERED_CORRECTLY = <any>"PreviouslyAnsweredCorrectly",
    ANSWERED_WITHOUT_EVALUATION = <any>"AnsweredWithoutEvaluation",
    PREVIOUSLY_NOT_ANSWERED = <any>"PreviouslyNotAnswered"
}

export interface IReviewWord {
    glossary: string;
    reviewReason: ReviewWordReason;
    word: string;
    wordColor: ReviewWordColor;
    wordId: number;
}

export interface IStoryState {
    canPlayback: boolean;
    currentPageId: number;
    currentQuizQuestionId: number;
    currentQuizQuestionState: QuestionState;
    currentSentenceId: number;
    currentStep: BookSessionType;
    hasQuizStar: boolean;
    hasRecordingStar: boolean;
    hasTAQStar: boolean;
    highestWcpm: number;
    lastQuizId: number;
    quizCompletionState: CompletionState;
    quizCount: number;
    quizPoint: number;
    quizQuestionStates: QuestionStateMap;
    recordCompletionState: CompletionState;
    recordCount: number;
    recordReadingStates: RecordReadingStateMap;
    recordingBadge: RecordingBadge;
    recordingPoint: number;
    reviewWords: IReviewWord[];
    selectionReportDate: string;
    storyCompletionState: CompletionState;
    storyUniqName: string;
    taqCompletionState: CompletionState;
    thinkAboutQuestionPoint: number;
    thinkAboutQuestionStates: QuestionStateMap;
    totalPoint: number;
    wcpm: number;
    wordWallMode: WordWallMode;
}

export interface IUserModel {
    currentStoryState: IStoryState;
    learnerId: string;
    learnerName: string;
    storyStateList: IStoryState[];
    totalPoint: number;
}

export interface IUserModelResponse {
    UserModel: IUserModel;
    Description: string;
    StatusCode: number;
}

export interface IUserModelDelta {
    // stores information for things that need to happen on a transition,
    // for example going from recording not complete --> recording complete triggers fluency report
    canPlayback: boolean; // not technically a delta, but needed for some events.
    currentStep: BookSessionType;
    justChangedStep: boolean;
    justCompletedSelection: boolean;
    justCompletedRecording: boolean;

    justCompletedTAI: boolean;
    justCompletedRequiredRecordings: boolean;
    justCompletedQuiz: boolean;
    justCompletedSentence: boolean; // in recording

    // are we initializing usermodel for the first time for that selection
    initializeState: boolean;
}
